import api from './api.js';

export const reportsService = {
  // Generate report card
  generateReportCard: (studentId, params = {}) => 
    api.get(`/reports/student/${studentId}/report-card`, { params }),
  
  // Download report card PDF
  downloadReportCard: (studentId, params = {}) =>
    api.get(`/reports/student/${studentId}/report-card/download`, { 
      params, 
      responseType: 'blob' 
    }),
  
  // Get student rankings
  getStudentRankings: (studentId, params = {}) =>
    api.get(`/reports/student/${studentId}/rankings`, { params }),
  
  // Get performance trends
  getPerformanceTrends: (studentId, params = {}) =>
    api.get(`/reports/student/${studentId}/performance-trends`, { params }),
  
  // Get class rankings
  getClassRankings: (classId, params = {}) =>
    api.get(`/reports/class/${classId}/rankings`, { params }),
  
  // Get academic summary
  getAcademicSummary: (studentId, params = {}) =>
    api.get(`/reports/student/${studentId}/academic-summary`, { params }),
  
  // Get class report cards
  getClassReportCards: (classId, params = {}) =>
    api.get(`/reports/class/${classId}/report-cards`, { params }),
  
  // Generate bulk report cards
  generateBulkReportCards: (data) =>
    api.post('/reports/bulk-report-cards', data),
  
  // Get academic analytics
  getAcademicAnalytics: (params = {}) =>
    api.get('/reports/analytics/academic', { params }),
  
  // Get performance comparison
  getPerformanceComparison: (data) =>
    api.post('/reports/analytics/performance-comparison', data),
  
  // Get report card templates
  getReportCardTemplates: () =>
    api.get('/reports/templates'),
};

